import { countries_code } from "./constants";

const CURRENCY_BY_ISO = {
  AD: "EUR",
  AE: "AED",
  AG: "XCD",
  AI: "XCD",
  AM: "AMD",
  AO: "AOA",
  AR: "ARS",
  AT: "EUR",
  AU: "AUD",
  AW: "AWG",
  AZ: "AZN",
  BA: "BAM",
  BB: "BBD",
  BD: "BDT",
  BE: "EUR",
  BF: "XOF",
  BH: "BHD",
  BI: "BIF",
  BJ: "XOF",
  BM: "BMD",
  BN: "BND",
  BO: "BOB",
  BR: "BRL",
  BS: "BSD",
  BT: "BTN",
  BW: "BWP",
  BY: "BYN",
  BZ: "BZD",
  CA: "CAD",
  CF: "XAF",
  CG: "XAF",
  CH: "CHF",
  CK: "NZD",
  CL: "CLP",
  CM: "XAF",
  CN: "CNY",
  CO: "COP",
  CR: "CRC",
  CS: "RSD",
  CU: "CUP",
  CV: "CVE",
  CY: "EUR",
  CZ: "CZK",
  DE: "EUR",
  DJ: "DJF",
  DK: "DKK",
  DM: "XCD",
  DO: "DOP",
  DZ: "DZD",
  EC: "USD",
  EE: "EUR",
  EG: "EGP",
  ER: "ERN",
  ES: "EUR",
  ET: "ETB",
  FI: "EUR",
  FJ: "FJD",
  FK: "FKP",
  FM: "USD",
  FO: "DKK",
  FR: "EUR",
  GA: "XAF",
  GB: "GBP",
  GD: "XCD",
  GE: "GEL",
  GF: "EUR",
  GH: "GHS",
  GI: "GIP",
  GL: "DKK",
  GM: "GMD",
  GN: "GNF",
  GP: "EUR",
  GQ: "XAF",
  GR: "EUR",
  GT: "GTQ",
  GU: "USD",
  GW: "XOF",
  GY: "GYD",
  HK: "HKD",
  HN: "HNL",
  HR: "EUR",
  HT: "HTG",
  HU: "HUF",
  ID: "IDR",
  IE: "EUR",
  IL: "ILS",
  IN: "INR",
  IQ: "IQD",
  IR: "IRR",
  IS: "ISK",
  IT: "EUR",
  JM: "JMD",
  JO: "JOD",
  JP: "JPY",
  KE: "KES",
  KG: "KGS",
  KH: "KHR",
  KI: "AUD",
  KM: "KMF",
  KN: "XCD",
  KP: "KPW",
  KR: "KRW",
  KW: "KWD",
  KY: "KYD",
  KZ: "KZT",
  LA: "LAK",
  LB: "LBP",
  LI: "CHF",
  LK: "LKR",
  LR: "LRD",
  LS: "LSL",
  LT: "EUR",
  LU: "EUR",
  LV: "EUR",
  LY: "LYD",
  MA: "MAD",
  MC: "EUR",
  MD: "MDL",
  MG: "MGA",
  MH: "USD",
  MK: "MKD",
  ML: "XOF",
  MN: "MNT",
  MP: "USD",
  MQ: "EUR",
  MR: "MRU",
  MS: "XCD",
  MT: "EUR",
  MV: "MVR",
  MW: "MWK",
  MX: "MXN",
  MY: "MYR",
  MZ: "MZN",
  NA: "NAD",
  NC: "XPF",
  NE: "XOF",
  NF: "AUD",
  NG: "NGN",
  NI: "NIO",
  NL: "EUR",
  NO: "NOK",
  NP: "NPR",
  NR: "AUD",
  NU: "NZD",
  NZ: "NZD",
  OM: "OMR",
  PE: "PEN",
  PF: "XPF",
  PG: "PGK",
  PH: "PHP",
  PK: "PKR",
  PL: "PLN",
  PR: "USD",
  PT: "EUR",
  PW: "USD",
  PY: "PYG",
  QA: "QAR",
  RE: "EUR",
  RO: "RON",
  RU: "RUB",
  RW: "RWF",
  SA: "SAR",
  SB: "SBD",
  SC: "SCR",
  SD: "SDG",
  SE: "SEK",
  SG: "SGD",
  SH: "SHP",
  SI: "EUR",
  SK: "EUR",
  SL: "SLE",
  SM: "EUR",
  SN: "XOF",
  SO: "SOS",
  SR: "SRD",
  ST: "STN",
  SV: "USD",
  SZ: "SZL",
  TC: "USD",
  TG: "XOF",
  TH: "THB",
  TJ: "TJS",
  TM: "TMT",
  TN: "TND",
  TO: "TOP",
  TR: "TRY",
  TT: "TTD",
  TV: "AUD",
  TW: "TWD",
  UA: "UAH",
  UG: "UGX",
  US: "USD",
  UY: "UYU",
  UZ: "UZS",
  VA: "EUR",
  VE: "VES",
  VG: "USD",
  VI: "USD",
  VN: "VND",
  VU: "VUV",
  WF: "XPF",
  YE: "YER",
  YT: "EUR",
  ZA: "ZAR",
  ZM: "ZMW",
  ZW: "ZWL",
};

export const sortedCountries = [...countries_code].sort((a, b) =>
  a.value.localeCompare(b.value)
);

export function getCurrencyForIso(isoCode) {
  if (!isoCode) return "";
  const normalized = String(isoCode).trim().toUpperCase();
  return CURRENCY_BY_ISO[normalized] || "";
}

export function getCountryByName(countryName) {
  return countries_code.find((country) => country.value === countryName) || null;
}

export function getCountryNameByCode(countryCode) {
  if (!countryCode) return "—";
  const normalized = String(countryCode).trim().toUpperCase();
  const country = countries_code.find(
    (item) => String(item.IsoCode).trim().toUpperCase() === normalized
  );
  return country?.value || countryCode;
}

export function resolveCountryMeta(countryName) {
  const country = getCountryByName(countryName);
  if (!country) {
    return {
      country_name: "",
      country_code: "",
      currency_code: "",
    };
  }

  const countryCode = String(country.IsoCode).trim().toUpperCase();

  return {
    country_name: country.value,
    country_code: countryCode,
    currency_code: getCurrencyForIso(countryCode),
  };
}

export function resolveCountryMetaByCode(countryCode) {
  const countryName = getCountryNameByCode(countryCode);
  if (countryName === countryCode) {
    return {
      country_name: "",
      country_code: String(countryCode || "").trim().toUpperCase(),
      currency_code: getCurrencyForIso(countryCode),
    };
  }

  return resolveCountryMeta(countryName);
}
